import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { usePermission } from '~/hooks/usePermission';
import { api } from '~/redux/api/createApi';

export const useWorkflowRoutingEnabled = (): boolean => {
  const hasWorkflowRoutingAgent = useFlag(FlagType.WorkflowRoutingAgent);
  const { data: routingConfig } =
    api.endpoints.getRoutingConfiguration.useQuery(undefined);

  const { hasPermission: hasAskAIPermission } = usePermission({
    permission: {
      resourceId: 'conversational_ai',
      resourceType: 'view',
    },
  });

  const { hasPermission: hasTicketAccessPermission } = usePermission({
    permission: {
      resourceId: 'workflow_tickets',
      resourceType: 'view',
    },
  });

  return (
    hasWorkflowRoutingAgent &&
    routingConfig?.allUserActivationStatus === 'active' &&
    !!hasAskAIPermission &&
    !!hasTicketAccessPermission
  );
};
